// Module
var code = " <gb-button ng-click=\"$ctrl.addWidget()\" icon=\"add\"> <span translate=\"ADD_HONOUR_ROLL_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-honour-roll-widget widget=\"$ctrl.getWidget()\" ng-if=\"$ctrl.getWidget()\"> </gb-edit-honour-roll-widget> ";
// Exports
export default code;